/**
 * @flow
 */

import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import { Form } from 'semantic-ui-react';

import ConnectionFields from './ConnectionFields';

type FieldListProps = {
    salons: Array<Object>,
    manufacturers: Array<Object>,
};

function FieldList({ salons, manufacturers }: FieldListProps) {
    const { control } = useFormContext();
    const { fields, append, remove } = useFieldArray({ control, name: 'items' });

    return (
        <div>
            {fields.map((field, idx) => (
                <Form.Field key={field.id}>
                    <ConnectionFields
                        index={idx}
                        salons={salons || []}
                        manufacturers={manufacturers || []}
                        onRemove={() => remove(idx)}
                    />
                </Form.Field>
            ))}
            <a
                href="#add"
                onClick={e => {
                    e.preventDefault();
                    append({});
                }}
            >
                <FormattedMessage
                    id="pages.suppliers.supplierForm.salonConnection.addNew"
                    defaultMessage="Add new +"
                />
            </a>
        </div>
    );
}

export default FieldList;
